import { useContext } from 'react';

import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@material-ui/core';

import { MAIN_CONTAINER_ID } from '../../constants';
import { DeviceContext } from '../../contexts';
import { ButtonTitleWithLoading } from '../ButtonTitleWithLoading';
import { ImageUploader } from '../ImageUploader';
import { Image } from '@vyce/core/src/types';

export const ChatChangeAvatarDialog = ({
  open,
  handleClose,
  loading,
  confirmFunction,
  avatar,
  setAvatar,
}: {
  open: boolean;
  handleClose: () => void;
  loading: boolean;
  confirmFunction: () => void;
  avatar: Image;
  setAvatar: (avatar: Image) => void;
}) => {
  const { isMobile } = useContext(DeviceContext);

  const handleImageUpload = (avatar: Image) => {
    setAvatar(avatar);
  };

  return (
    <Dialog
      container={document.getElementById(MAIN_CONTAINER_ID)}
      fullScreen={isMobile}
      maxWidth="xs"
      fullWidth
      open={open}
      onClose={handleClose}
    >
      <DialogTitle>Change chat avatar</DialogTitle>

      <DialogContent>
        <ImageUploader
          image={avatar}
          onImageUpload={handleImageUpload}
          extraText="picture"
          buttonPosition={{ top: 0, right: 0 }}
          outsideControl
        />
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" onClick={handleClose}>
          Cancel
        </Button>

        <Button
          style={{ width: 130 }}
          disabled={loading}
          onClick={confirmFunction}
          color="primary"
          variant="contained"
        >
          <ButtonTitleWithLoading title="Save changes" loaderVariant="paper" loading={loading} />
        </Button>
      </DialogActions>
    </Dialog>
  );
};
